// Version : 0.0.2
// Author : AGALYA
// LAST EDIT DONE BY : Shiyam
// LastEdit : Added version
// MODFIED DATA : 23-09-2025

const overDueReportTypes = {
	/** ***************** GET OVERDUE REPORT DETAILS START *********************** */
	GET_OVERDUE_REPORT_LIST_START: 'get_overdue_report_list_start',
	GET_OVERDUE_REPORT_LIST_SUCCESS: 'get_overdue_report_list_success',
	GET_OVERDUE_REPORT_LIST_FAILURE: 'get_overdue_report_list_failure',
	GET_OVERDUE_REPORT_LIST_RESPONSE_RESET: 'get_overdue_report_list_response_reset',
	GET_OVERDUE_REPORT_LIST_RESPONSE_CHANGED: 'get_overdue_report_list_response_changed',
	/** ***************** GET OVERDUE REPORT DETAILS END *********************** */
};
export default overDueReportTypes;
